<template>
    <div>
        <form-input :placeholder="placeholder" :label="label" :value="displayedValue"
            ref="field" autocomplete="off" @focus="showModal" :disabled="disabled"></form-input>
        <modal v-model="modalShown" :title="title" @hidden="onHide" size="large">
            <div class="row">
                <div class="col-sm-12">
                    <form-input v-model="needle" @input="initSearch" placeholder="Search" ></form-input>
                </div>
            </div>
            <div class="container bg-translucent-neutral" style="min-height: 300px">
                <div class="row options-container" ref="optionsContainer">
                    <modal-selector-option v-for="option in options" :key="option[valueKey]"
                        @select="toggleOption" :value="option"
                        :display-name="option[displayKey]"
                        :sub-name="subNameKey ? option[subNameKey] : subName"
                        :is-selected="isSelected(option)"
                        :disabled="multiple && !(selected.length < maximumSelected || isSelected(option))"
                    >
                    </modal-selector-option>
                    <div v-if="fetching" class="col-sm-12 text-center pt-3">
                        <i class="fa fa-spinner fa-spin pr-1"></i>
                        Loading data, please wait ...
                    </div>
                    <div v-else-if="options.length == 0" class="col-sm-12 text-center pt-3">
                        No records found
                    </div>
                </div>
            </div>
            <template slot="footer">
                <div class="text-right">
                    <button type="button" class="btn btn-warning long" @click="save">
                        <i class="fa fa-save mr-1"></i> Save
                    </button>
                </div>
            </template>
        </modal>
    </div>
</template>
<script>
import mixins from '@utils/mixins';
import { route, get } from '@utils/network';
import ModalSelectorOption from './ModalSelectorOption';

export default {
    name: 'ModalSelector',
    components: { ModalSelectorOption },
    computed: {
        displayedValue() {
            return this.initialData.selected.map(item => item[this.displayKey]).join(', ');
        },
        maximumSelected() {
            const max = this.max || 9999999999;
            return this.multiple ? max : 1;
        },
        hasMore() {
            return !!(this.pagination.next_page_url || this.pagination.next);
        },
    },
    data: () => ({
        initialData: {
            data: [],
            selected: []
        },
        error: "",
        link: '',
        fetching: true,
        pagination: { next_page_url: true },
        data: [],
        modalShown: false,
        selected: [],
        needle: "",
        searchTimeout: null,
        options: [],
    }),

    methods: {
        clear() {
            this.clearOptions();
            this.selected = this.multiple ? [] : null;
            this.initialData = {
                data: [],
                selected: []
            };
            this.error = null;
        },

        closeModal() {
            return this.modalShown = false;
        },

        syncValues() {
            if (this.multiple) {
                this.selected = this.selected.filter(item => this.value.indexOf(item.id) >= 0)
            }
        },

        isSelected(option) {
            this.$refs.field.error ? this.$refs.field.clearError() : null;
            return this.indexOfOption(option) >= 0;
        },

        resetData() {
            this.data = [...this.initialData.data];
            this.selected = [...this.initialData.selected];
        },

        onHide() {
            this.modalShown = false;
            this.resetData();
        },

        showModal() {
            if (this.disabled) {
                return;
            }
            this.modalShown = true;
        },

        initSearch() {
            clearTimeout(this.searchTimeout)
            this.searchTimeout = setTimeout(() => {
                this.search(this.selected);
            }, 1000);
        },

        search(values = []) {
            this.clearOptions();
            this.link = this.fetchLink || route(this.fetchRoute, this.fetchParams);
            this.fetchData(values);
        },

        fetchData(values = []) {
            this.fetching = true;
            values = Array.isArray(values) && values.length > 0 ? values : this.value;
            values = Array.isArray(values) || values == null ? values : [this.value];
            get(this.link, { params: { ...this.params, search: this.needle, priority: values }})
                .then(response => this.mapResponse(response, values))
                .catch(error => this.fetchFailed(error))
                .finally(() => this.fetching = false);
        },

        clearOptions() {
            this.options = [];
            // this.selected = this.selected.filter(item => this.value.indexOf(item[this.valueKey]) >= 0);
        },
        
        isNearToBottom(table) {
            return table.scrollTop + table.clientHeight > table.scrollHeight - 100;
        },
        
        loadNewData(event) {
            let table = event.target;
            if (this.fetching || !this.hasMore || !this.isNearToBottom(table))  {
                return;
            }
            this.fetchData();
        },

        getPaginationData(response) {
            this.paginatePath.split('.')
                .forEach(index => response = response[index]);
            return response;
        },

        mapResponse(response, value = []) {
            this.pagination =this.getPaginationData(response);
            this.link = this.pagination.next_page_url || this.pagination.next
            this.options.push(...this.pagination.data);
            if ((this.multiple && value.length > 0) || (!this.multiple && value)) {
                let selectedOptions = this.multiple
                    ? this.pagination.data.filter(item => value.indexOf(item[this.valueKey]) >= 0)
                    : this.pagination.data.filter(item => value == item[this.valueKey]);
                this.selected = [...selectedOptions];
                this.commitData();
            }
        },

        fetchFailed(error) {
            this.promptErrors(error.response.data.message);
        },

        toggleOption(option) {

            if (this.multiple) {
                option.selected
                    ? this.selected.push(option.value)
                    : this.indexOfOption(option.value) >= 0
                        ? this.selected.splice(this.indexOfOption(option.value), 1) : "";
            } else {
                this.selected = option.selected ? [option.value] : [];
            }

            // if (this.multiple || !option.selected || (option.selected && !this.multiple && this.selected.length < 1)) {
            //     option.selected
            //         ? this.selected.push(option.value)
            //         : this.indexOfOption(option.value) >= 0
            //             ? this.selected.splice(this.indexOfOption(option.value), 1) : "";
            // } else if (!this.multiple && this.selected.length >= 1) {
            //     option.component.selected = false;
            // }

            // if (!this.multiple && this.selected.length == 1) {
            //     return this.closeModal();
            // }
        },

        commitData() {
            this.initialData.data = [...this.data];
            this.initialData.selected = [...this.selected];
        },

        save(e, closeModal = true) {
            this.commitData();
            this.emitChanges();
            closeModal ? this.closeModal() : null;
        },

        emitChanges() {
            const option = this.multiple ? this.selected : (this.selected.length > 0 ? this.selected[0] : {});
            const value = Array.isArray(option) ? option.map(i => i[this.valueKey]) : option[this.valueKey] || "";

            this.$emit('change', option);
            this.$emit('input', value);
        },

        indexOfOption(option) {
            if (typeof option != 'object') {
                return this.selected.indexOf(option)
            }
            for (const key in this.selected) {
                if (this.selected[key][this.valueKey] == option[this.valueKey]) {
                    return key;
                }
            }
            return -1;
        },
        
        initializeValue() {
            this.search(this.initialValue);
        },

        clearValue() {
            this.selected = [];
            this.initialData.selected = [];
        }

    },

    mixins: [ mixins ],

    props: {
        value: Array|Number|String|Object,
        subName: String,
        subNameKey: String,
        title: String,
        label: String,
        placeholder: String,
        fetchLink: String,
        fetchRoute: String,
        fetchParams: Object|Array|Number,
        paginatePath: String,
        params: Object,
        max: Number,
        multiple: {
            type: Boolean,
            default: false,
        },
        valueKey: {
            type: String,
            default: "id"
        },
        displayKey: {
            type: String,
            default: "name"
        },
        initialValue: Array|Number,
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    watch: {
        modalShown(newValue) {
            if (!newValue) {
                return;
            }
            this.clearOptions();
            this.search();
        },

        error() {
            this.$nextTick(() => {
                this.$refs.field.error = this.error
            });
        }
    },

    mounted() {
        if (this.initialValue) {
            this.initializeValue();
        }
        setTimeout(() => this.$refs.optionsContainer.onscroll = (e) => this.loadNewData(e), 1000);
    }
}
</script>
<style lang="css" scoped>
    .options-container {
        max-height: 360px;
        overflow: auto;
    }
</style>